import React, { Component } from 'react'
import './index.css'
import { BsyUtils } from "../../utils/Utils";
import BsyTableList from "../BsyTableList";
import LoginAccountInput from "../../Login/LoginAccountInput";
import BsyIconBtn from "../BsyIconBtn";
import BsyRadioGroup from '../BsyRadioGroup';
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyDialog from '../BsyDialog';
import BsyAlertListDetail from '../BsyAlertListDetail';

class CorpCoopRolePane extends Component {
    static defaultProps = {
        item: {},
        corpCoopMap:{},
        contactMap:{},
        deptMapList:{},
        guestMapList:{},
        hostMapList:{},
        owner_coprs:[],
        corpUserType: "other",
        isOther: false,
    }
    constructor(props) {
        super(props);
        this.state = {
            item: props.item,
            corpCoopMap:props.corpCoopMap,
            contactMap:props.contactMap,
            corpUserType:props.corpUserType,
            selectType: props.selectType,
            selectGroup: props.selectGroup,
            deptMapList: props.deptMapList,
            guestMapList: props.guestMapList,
            hostMapList: props.hostMapList,
            isOther: props.isOther,
            owner_coprs: props.owner_coprs,
            nameWidth: 0
        }
    }

    closeAlert = () =>{
        this.props.newProps && this.props.newProps.props &&  this.props.newProps.props.onRemoveRoot && this.props.newProps.props.onRemoveRoot();
    }

    getTableValue = (ref) =>{
        console.log(ref)
    }

    changeName = (event) =>{
        let name = event.target.value;
        let { item } = this.state;
        item.name = name;
        this.setState({item});
    }



    _createChangeRoleBubble = () =>{
        const {item} = this.state;
        const _this = this;
        let items = item;
        React.axios("/corp/dock/role/list").then(res=>{
            const d = new window.FX.ConfirmDialog({
                title: React.language("contact.external.role.list"),
                height: 576,
                width: 710,
                contentWidget: {
                    rowSize: [440],
                    colSize: [680],
                    padding: 15,
                    items: [[{
                        widgetName: "memberSelect",
                        type: "memberselectpane",
                        
                        editable: !0,
                        hasMenuType:false,
                        memberEnable: !1,
                        departmentEnable: !1,
                        outsiderMemberEnable: !1,
                        outsiderGroupEnable: !1,
                        roleEnable: !1,
                        corpEnable: !0,
                        dynamicEnable: !1,
                        dynamicType: "set",
                        iconType: "corpRole",
                        itemTitle: React.language("role"),
                        items: res.data.role_list,
                        value: item.role_id,
                    }]]
                },
                onOk: function () {
                    var dept = d.getWidgetByName("memberSelect");
                    var d1 = dept.getAllJsonValue();
                    items.role_id = d1.corpRoleValue;
                    _this.setState({item: items});
                    return !1;
                }
            });
            d.show()
        })
    }

    _createChangeDepartmentBubble = () =>{
        const {item} = this.state;
        const _this = this;
        let items = item;
        const d = new window.FX.ConfirmDialog({
            title: React.language("contact.corp.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    hasMenuType:false,
                    memberEnable: !1,
                    departmentEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !1,
                    corpEnable: !0,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    value: items.corp_id_list,
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                items.corp_id_list = d1.dockcorpValue;
                _this.setState({item: items});
                return !1;
            }
        });
        d.show()
    }

    onSave = () =>{
        const {item} = this.state;
        const {isCorpDept} = this.props;
        let items = item;
        let countryCode = this.phoneEl ? this.phoneEl.state.countryCode : "+86";
        let phone = this.phoneEl ? this.phoneEl.state.value : null;
        let email = this.emailEl ? this.emailEl.state.value : null;
        let url = "/corp/dock/member/update";
        let data = {
            'dock_corpid':item.dock_corpid, //必填
            'new_dock_corpid': item.new_dock_corpid,
            'dock_corpid_list': item.corp_id_list,
            "name":item.name,
            "corp": item.guest_corp_list,
            "role_id_list":item.role_id_list,
            "role_id":item.role_id,
        }
        if(isCorpDept){
            data.is_global_dept = item.is_global_dept;
            data.dept_id = item.dept_id;
            url = "/corp/dock/dept/update";
        }else{
            data.is_global_docker = item.is_global_docker;
            data.user_id = item.user_id;
            data.countryCode = countryCode;
            data.mobile = phone;
            data.email = email;
        }
        React.axios(url,data).then(res=>{
            if(res.data.errcode !== 0){
                tipAlert({
                    type: 'warning',
                    msg: res.data.errmessage
                })
                return
            }
            tipAlert({
                type: "success",
                msg: React.language("datahelper.trigger.output.filter.ok.tip")
            })
            items.dock_corpid = item.new_dock_corpid;
            items.country_code = countryCode;
            items.mobile = phone;
            items.email = email;
            this.setState({item: items})
            this.props.changeDockCorp && this.props.changeDockCorp(item)
            this.props.RefreshList();
            this.closeAlert()
        })
    }

    dismissionClick = () =>{
        const {item, selectType, selectGroup, isOther} = this.state;
        let titile = '', msg = '';
        if(selectGroup === "corpCoopAll"){
            titile = React.language("contact.connection.selected.remove");
            msg = React.language("contact.connection.selected.remove.tip");
            
        }else if(selectGroup === "corpDeptAll"){
            titile = React.language("contact.our.dept.remove.title");
            msg = React.language("contact.our.dept.remove.tip");
        }else{
            titile = React.language("contact.our.docker.remove.title");
            msg = React.language("contact.our.docker.remove.tip");
        } 
        BsyAlert({
            title: titile,
            msg: msg,
            type: "warning",
            text4Ok: React.language("delete"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                if(isOther){
                    if(selectGroup === "corpDeptAll"){
                        React.axios("/corp/dock/dept/remove",{corp_id: [], dept_id: [item.dept_id], mode: "guest"}).then(res=>{
                            if(res.data.errcode !== 0){
                                tipAlert({
                                    type: 'warning',
                                    msg: res.data.errmessage
                                })
                                return
                            }
                            this.props.RefreshList();
                            this.closeAlert()
                        })
                    }else{
                        React.axios("/corp/dock/member/remove",{corp_id: [], user_id: [item.user_id], mode: isOther ? "guest" : "host"}).then(res=>{
                            if(res.data.errcode !== 0){
                                tipAlert({
                                    type: 'warning',
                                    msg: res.data.errmessage
                                })
                                return
                            }
                            this.props.RefreshList();
                            this.closeAlert()
                        })
                    }
                }else{
                    if(selectType === "contactAll"){
                        if(selectGroup === "contactAll"){
                            React.axios("/corp/dock/member/delete",{corp_id: [item.owner_corpid], type: "corp", user_id: [item.user_id]}).then(res=>{
                                if(res.data.errcode !== 0){
                                    tipAlert({
                                        type: 'warning',
                                        msg: res.data.errmessage
                                    })
                                    return
                                }
                                this.props.removeCorpRole && this.props.removeCorpRole(item);
                                this.props.RefreshList();
                                this.closeAlert()
                            })
                        }else if(selectGroup === "corpDeptAll"){
                            React.axios("/corp/dock/dept/remove",{corp_id: [], dept_id: [item.dept_id], mode: "guest"}).then(res=>{
                                if(res.data.errcode !== 0){
                                    tipAlert({
                                        type: 'warning',
                                        msg: res.data.errmessage
                                    })
                                    return
                                }
                                this.props.removeCorpRole && this.props.removeCorpRole(item);
                                this.props.RefreshList();
                                this.closeAlert()
                            })
                        }else{
                            React.axios("/corp/dock/member/delete",{corp_id: [selectGroup], type: "role", user_id: [item.user_id]}).then(res=>{
                                if(res.data.errcode !== 0){
                                    tipAlert({
                                        type: 'warning',
                                        msg: res.data.errmessage
                                    })
                                    return
                                }
                                this.props.removeCorpRole && this.props.removeCorpRole(item);
                                this.props.RefreshList();
                                this.closeAlert()
                            })
                        }
                    }else{
                        React.axios("/corp/dock/member/delete",{corp_id: [item.owner_corpid], type: "corp", user_id: [item.user_id]}).then(res=>{
                            if(res.data.errcode !== 0){
                                tipAlert({
                                    type: 'warning',
                                    msg: res.data.errmessage
                                })
                                return
                            }
                            this.props.removeCorpRole && this.props.removeCorpRole(item);
                            this.props.RefreshList();
                            this.closeAlert()
                        })
                    }
                }
            }
        })
        
    }

    phoneValue = (ref) =>{
        this.phoneEl = ref
    }
    emailValue = (ref) =>{
        this.emailEl = ref
    }

    openCorpOwner = (event) =>{
        const {item, owner_coprs} = this.state;
        let items = item;
        const canEditCorp = item.corp_status == 0 && item.is_tmp_owner == 1 && (item.category == -1 || item.category == 2);
        if(!canEditCorp){
            return
        }
        let dockCorpOwnerList = owner_coprs.map(res=>{
            return {
                text: res.dock_corpname,
                value: res.dock_corpid,
                extIcon: res.dock_corpid === item.dock_corpid ? "icon-ok" : "",
                click: () =>{
                    items.dock_corpname = res.dock_corpname;
                    items.new_dock_corpid = res.dock_corpid;
                    this.setState({item: items})
                }
            }
        })
        BsyAlertMenu({
            item: dockCorpOwnerList,
            width: 352,
            target: event.target,
            customCls: ' corprole-batch-menu ',
        })
    }

    render() {
        const { item, nameWidth, corpCoopMap, contactMap, corpUserType, selectType, selectGroup, deptMapList, hostMapList, guestMapList, isOther, owner_coprs } = this.state;
        const { mobileCodeLogin, emailCodeLogin, isCorpDept } = this.props;
        const bg = item.name ? BsyUtils.formatUserThumb(item.name.toString()) : '';
        let dockCorpList = [];
        const canEditCorp = item.corp_status == 0 && item.is_tmp_owner == 1 && (item.category == -1 || item.category == 2);
        const canEditPhoneEmail = (item.corp_status == 0 && item.is_tmp_owner == 1) ||  (item.corp_status == 1 && item.is_tmp_owner == 1 && item.category == -1);
        if(isOther){
            dockCorpList = [...item.corp_id_list];
        }
        const is_global = isCorpDept ? item.is_global_dept : item.is_global_docker;
        return (
            <div className="CorpCoopRolePane">
                <div className="header-pane">
                    {!isCorpDept ? <div className="avatar">
                        {item.avatarurl ? <img src={item.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                    </div> : <div className='avatar-dept'>
                        <i className="icon-form-new-flow"></i>
                    </div>}
                    <div className="headerDetail">
                        <div className="name">
                            <span className="tName">{item.name}</span>
                            {item.category === 0 && <span className="category">{React.language('manager.creator')}</span>}
                        </div>
                        {!isCorpDept && <div className="account">
                            <span className="detailTitle">{React.language('receipt.account') + "："}</span>
                            <span className="detailText">{item.user_id}</span>
                        </div>}
                    </div>
                    <div className="alertClose">
                        <i onClick={this.closeAlert} className="icon-close-large" />
                    </div>
                </div>

                <div className="detailCont">
                    <div className="name line">
                        <div className="detailTitle">
                            <span className="req">*</span>
                            <span>{!isCorpDept ? React.language('name') : React.language('department')}</span>
                        </div>
                        {(isOther || item.user_type === "dock_dept_user") ? <div className="input_isreadonly">{item.name}</div> : <input value={item.name} maxLength={16} onChange={this.changeName} type="text" />}
                    </div>
                    <div className="enterprise line">
                        {isOther ? <>
                            <div className="detailTitle">
                                <span>{React.language('contact.docking.corp')}</span>
                            </div>
                            <BsyRadioGroup
                                layout={'horizontal'}
                                value={is_global}
                                required={true}
                                items={[{
                                    value: true,
                                    text: React.language('contact.corp.all'),
                                }, {
                                    value: false,
                                    text: React.language('contact.corp.some'),
                                }]}
                                onStopEdit={(e, s, t) => {
                                    let items = {...item};
                                    if(e !== ""){
                                        if(isCorpDept){
                                            items.is_global_dept = e;
                                        }else{
                                            items.is_global_docker = e;
                                        }
                                        
                                    }
                                    this.setState({
                                        item:items
                                    })
                                }}
                            ></BsyRadioGroup>
                            {   
                                !is_global ? <div className='corpCont' onClick={this._createChangeDepartmentBubble}>
                                    {
                                        (dockCorpList && dockCorpList.length > 0) ? dockCorpList.map(res => {
                                            let id = res.split('-')[0];
                                            let name = hostMapList[id] ? hostMapList[id].dock_corpname : guestMapList[id] ? guestMapList[id].dock_corpname : "";
                                            return name && <div className="item-content department"><i className="icon-all-corp" /><span>{name}</span></div>
                                        }) : <div className="select-empty"><span>{React.language('label.select1')}</span></div>
                                    }
                                </div> : <div className='allCorpTip'>
                                    <span>{React.language('contact.docking.corp.tip')}</span>
                                </div>
                            }
                        </> : <>
                            <div className="detailTitle">
                                <span className="req">*</span>
                                <span>{React.language('enterprise')}</span>
                            </div>
                            <div className={"onlyRead-combox" + (!canEditCorp ? " isreadonly" : "")} onClick={this.openCorpOwner}>
                                <input value={item ? item.dock_corpname : ""} type="text" readOnly />
                                <i className='icon-bsy-xia'></i>
                            </div>
                        </>}
                    </div>
                    {!isCorpDept && <div className="phone line">
                        <div className="detailTitle">
                            {mobileCodeLogin && <span className="req">
                                *
                            </span>}
                            <span>
                                {React.language('widget.phone')}
                            </span>
                        </div>
                        <LoginAccountInput phoneType={item.country_code} getValue={this.phoneValue} isreadonly={!canEditPhoneEmail} change={this.changePhone} mobileType={item.country_code} error={false} maxLength="12" value={item.mobile} mode="mobile" placeholder={React.language('phone.entry.tip')} />
                        {item.mobilestatus === 0 && <div className="line-tip">
                            {React.language('contact.docker.phone.verify.tip',{productName:window._bby_config.site_name})}
                        </div>}
                    </div>}
                    {!isCorpDept && <div className="email line">
                        <div className="detailTitle">
                            {emailCodeLogin && <span className="req">
                                *
                            </span>}
                            <span>
                                {React.language('email')}
                            </span>
                        </div>
                        <LoginAccountInput getValue={this.emailValue} isreadonly={!canEditPhoneEmail} change={this.changePhone} error={false} maxLength="128" value={item.email} mode="email" placeholder={React.language('email.entry.tip')} />
                        {item.emailstatus === 0 && <div className="line-tip">
                            {React.language('contact.docker.email.verify.tip',{productName:window._bby_config.site_name})}
                        </div>}
                    </div>}
                    {!isCorpDept && <div className="role line">
                        {isOther ? <>
                            <div className="detailTitle">
                                <span>{React.language('department')}</span>
                            </div>
                            <div className='roleCont ban'>
                                {
                                    (item.deptids && item.deptids.length > 0) ? item.deptids.map(res => {
                                        let name = deptMapList[res] ? deptMapList[res].name : "";
                                        return <div className="item-content role"><i className="icon-role" /><span>{name}</span></div>
                                    }) : <div className="select-empty"><span>{React.language('widget.dept.clickToSelect')}</span></div>
                                }
                            </div>
                        </> : <>
                            <div className="detailTitle">
                                <span>{React.language('role')}</span>
                            </div>
                            <div className='roleCont' onClick={this._createChangeRoleBubble}>
                                {
                                    (item.role_id && item.role_id.length > 0) ? item.role_id.map(res => {
                                        let name = contactMap[res] ? contactMap[res].name : "";
                                        return <div className="item-content role"><i className="icon-role" /><span>{name}</span></div>
                                    }) : <div className="select-empty"><span>{React.language('role.select.tip')}</span></div>
                                }
                            </div>
                        </>}
                    </div>}
                </div>
                <div className="alertFooter">
                    {
                        <BsyIconBtn
                            text={React.language('modify')}
                            click={this.onSave}
                            iconName=""
                            type="border-blue"
                            mode={window.mode}
                        />
                    }

                    {<BsyIconBtn
                        text={React.language("remove.out")}
                        click={this.dismissionClick}
                        type="border-red"
                        mode={window.mode}
                    />}
                </div>
            </div>
        )
    }
}

export default CorpCoopRolePane